export default {"src":"/_next/static/media/search-not-found-red.34ac2c02.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};